import { render, staticRenderFns } from "./kaobo.vue?vue&type=template&id=427151bc&scoped=true"
import script from "./kaobo.vue?vue&type=script&lang=js"
export * from "./kaobo.vue?vue&type=script&lang=js"
import style0 from "./kaobo.vue?vue&type=style&index=0&id=427151bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427151bc",
  null
  
)

export default component.exports